import RequestService from '../../../services/request-service';
import DateFilterService from '../../../services/date-filter-service';

/**
 * Virtual Tennis Request Service
 */
export default class TopWinningsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor(timeframeString) {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.topWinnings;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';
    /**
     * Set post params
     * @type {{}}
     */
    this.getParams = {
      numItems: 10,
      winLoadPeriod: DateFilterService.parseOldAPIDateFilter(timeframeString),
      timeOffset: DateFilterService.utcTimeOffset(),
    };
    this.headers = null;
  }
}
